import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';

const MOODS = [
  { icon: '😊', label: 'Bine' },
  { icon: '😐', label: 'Ok' },
  { icon: '😟', label: 'Tensionat' },
  { icon: '😰', label: 'Anxios' },
  { icon: '😵', label: 'Copleșit' },
];

const greet = () => {
  const h = new Date().getHours();
  if (h < 12) return 'Bună dimineața';
  if (h < 18) return 'Bună ziua';
  return 'Bună seara';
};

export default function Home() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [selectedMood, setSelectedMood] = useState(null);
  const [streak, setStreak] = useState(0);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    axios.get('/api/mood').then(({ data }) => {
      if (data.length > 0) {
        const days = new Set(data.map(d => d.created_at.slice(0, 10)));
        setStreak(days.size);
      }
    }).catch(() => {});
  }, []);

  const saveMood = async (mood) => {
    setSelectedMood(mood.label);
    setSaving(true);
    try {
      await axios.post('/api/mood', { mood: mood.label, intensity: 5 });
    } catch {}
    setSaving(false);
  };

  return (
    <div className="page">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 4 }}>
        <div>
          <div style={{ fontSize: 22, fontWeight: 700 }}>{greet()}, {user?.name?.split(' ')[0]}</div>
          <div style={{ fontSize: 13, color: 'var(--muted)' }}>Cum te simți acum?</div>
        </div>
        <button onClick={logout} style={{ background: 'none', border: 'none', fontSize: 12, color: 'var(--muted)', cursor: 'pointer' }}>Ieși</button>
      </div>

      {/* Mood selector */}
      <div className="card-teal" style={{ marginTop: 16 }}>
        <div style={{ fontSize: 12, fontWeight: 700, color: '#0F6E56', marginBottom: 10 }}>STAREA DE ACUM</div>
        <div className="mood-row">
          {MOODS.map(m => (
            <button key={m.label} className={`mood-pill${selectedMood === m.label ? ' selected' : ''}`} onClick={() => saveMood(m)}>
              <span>{m.icon}</span>
              <span>{m.label}</span>
            </button>
          ))}
        </div>
        {selectedMood && (
          <div style={{ fontSize: 12, color: '#0F6E56', marginTop: 8, textAlign: 'center' }}>
            {saving ? 'Se salvează...' : `Starea "${selectedMood}" salvată ✓`}
          </div>
        )}
      </div>

      {/* Quick actions */}
      <div className="section-label">ACCES RAPID</div>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
        {[
          { icon: '🫁', title: 'Respirație', desc: 'Box · 4-7-8 · Coerență', path: '/breath' },
          { icon: '💬', title: 'Chat AI', desc: 'Suport conversațional', path: '/chat' },
          { icon: '📓', title: 'Jurnal', desc: 'Notează ce simți', path: '/journal' },
          { icon: '📊', title: 'Istoric', desc: 'Ultimele 30 de zile', path: '/journal' },
        ].map(item => (
          <div key={item.title} className="card" style={{ cursor: 'pointer' }} onClick={() => navigate(item.path)}>
            <div style={{ fontSize: 22, marginBottom: 6 }}>{item.icon}</div>
            <div style={{ fontWeight: 600, fontSize: 14 }}>{item.title}</div>
            <div style={{ fontSize: 11, color: 'var(--muted)', marginTop: 2 }}>{item.desc}</div>
          </div>
        ))}
      </div>

      {/* Streak */}
      <div className="section-label">PROGRES</div>
      <div className="card" style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
        <div className="streak-num">{streak}</div>
        <div>
          <div style={{ fontWeight: 600 }}>zile înregistrate</div>
          <div style={{ fontSize: 12, color: 'var(--muted)' }}>Continuă să îți monitorizezi starea</div>
        </div>
      </div>

      {/* Crisis banner */}
      <div className="card-danger" style={{ marginTop: 16, display: 'flex', alignItems: 'center', gap: 10 }}>
        <div style={{ flex: 1, fontSize: 12, color: '#7B2D36', lineHeight: 1.4 }}>
          Dacă ești în criză, sună <strong>TELVERDE 0800 800 100</strong> — gratuit, non-stop.
        </div>
      </div>
    </div>
  );
}
